import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonLabel } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { P00058EcremageTimerEnum } from '../../../Enum/P00058EcremageTimerEnum';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { P00058SpeedEnum } from '../../../Enum/P00058SpeedEnum';

@Component({
  selector: 'app-p00058-pompe-mise-en-oeuvre-filtration',
  templateUrl: './p00058-pompe-mise-en-oeuvre-filtration.component.html',
  styleUrls: ['./p00058-pompe-mise-en-oeuvre-filtration.component.scss'],
  imports: [
    AffichageWarningComponent,
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    IonLabel,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    TranslatePipe,
  ],
})
export class P00058PompeMiseEnOeuvreFiltrationComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  public translateService: TranslateService = inject(TranslateService);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.getEnSavoirPlus = this.getEnSavoirPlus.bind(this);
  }

  async getEnSavoirPlus() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00058.installation.ecremage.enSavoirPlus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getEcremageTimerEnum() {
    return P00058EcremageTimerEnum(this.translateService);
  }
  getSpeedEnum(min: number, max: number) {
    return P00058SpeedEnum(
      this.translateService,
      this.actionStack!.getValue('pvPUniteConsignePompe'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      min,
      max,
      5,
      this.actionStack!.getValue('pvSVitesseMinRpm'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      100,
    );
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00058SpeedEnum = P00058SpeedEnum;
}
